<template>
  <div class="container mt-5">
    <div class="row">
      <div class="text-center mb-5">
        <h1>中國醫藥大學新竹附設醫院</h1>
        <h2>視訊會診系統</h2>
      </div>
    </div>
    <form class="row justify-content-center" @submit.prevent="signIn">
      <div class="col-md-6">
        <h1 class="h3 mb-3 font-weight-normal" v-if="url == null">登入</h1>
        <div class="mb-2" v-if="url == null">
          <label for="id_number" class="sr-only">ID Number</label>
          <input
            type="text"
            id="id_number"
            class="form-control"
            placeholder="ID Number"
            required
            autofocus
            v-model="user.id_number"
          />
        </div>
        <div class="mb-2" v-if="url == null">
          <label for="password_number" class="sr-only">Password</label>
          <input
            type="password"
            id="password_number"
            class="form-control"
            placeholder="Password"
            required
            v-model="user.password_number"
          />
        </div>
        <div class="text-center mt-4" v-if="url == null">
          <button class="btn btn-lg btn-primary btn-block" type="submit" >
            登入
          </button>
        </div>
        <div class="alert mt-4">
          <div class="alert alert-primary" role="alert" v-if="url != null">
            登入成功，<a v-bind:href="url" class="alert-link">點我連結至視訊！</a>
          </div>
          <div class="alert alert-danger" role="alert" v-else>
            登入失敗，請再次確認帳號密碼！
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      user: {
        id_number: '',
        password_number: ''
      },
      url: null
    }
  },
  methods: {
    signIn () {
      const api = `http://220.130.50.225:8089/Cmuhch/Video_Consultation`
      fetch(api, {
        method: 'POST',
        body: JSON.stringify(this.user)
      })
        .then(res => res.json())
        .catch(error => {
          console.error('Error:', error)
        })
        .then(response => {
          console.log('Success:', response)
          if (response.status === true) {
            this.url = response.url
          }
        })
    }
  }
}
</script>
